<script>
//TODO: Actually this component doesn't work for video.

import CTA from '@phoenix/mixins/components/common/CTA';
import { showModal } from '@phoenix/helpers/modal-helper';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [CTA],

  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: 'button',
    },
    trackingEvent: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'plain',
    },
    color: {
      type: String,
      default: 'primary',
    },
    full: {
      type: Boolean,
      default: false,
    },
    expandTarget: {
      type: Boolean,
      default: false,
    },
    additionalClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    attributes() {
      const attributes = {};
      if (this.target.type === 'page' && this.target.openInNewWindow) {
        attributes.target = '_blank';
      }
      return attributes;
    },

    modalId() {
      switch (this.target.type) {
        case 'video':
          return this.target.videoModalId;
        case 'sharePage':
          return this.target.modalId;
        default:
          return null;
      }
    },

    shouldOpenModal() {
      return this.modalId !== null;
    },

    trackingDatalayer() {
      return this.trackingEvent ? window.tracking.getCustomEventTracking(this.trackingEvent) : null;
    },

    iconProp() {
      return this.icon ? { start: { id: this.icon, size: 'sm' } } : undefined;
    },

    forwardedAttrs() {
      const { class: _class, ...rest } = this.$attrs;
      return rest;
    },

    passthroughClasses() {
      return [this.additionalClasses, this.$attrs.class].filter(Boolean);
    },
  },
  methods: { showModal },
};
</script>

<template>
  <PhxsgButton
    v-if="shouldOpenModal"
    :type="type"
    :variant="variant"
    :color="color"
    :full="full"
    :expand-target="expandTarget"
    :icon="iconProp"
    :class="passthroughClasses"
    v-bind="{ ...forwardedAttrs, ...attributes }"
    @click="showModal(modalId)"
  >
    <span v-html="getText" />
  </PhxsgButton>

  <PhxsgButton
    v-else
    use="a"
    :href="link"
    :variant="variant"
    :color="color"
    :full="full"
    :expand-target="expandTarget"
    :icon="iconProp"
    :class="passthroughClasses"
    v-bind="{ ...forwardedAttrs, ...attributes }"
  >
    <span v-html="getText" />
  </PhxsgButton>
</template>
